import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { map } from 'rxjs';

import { MembersService } from '@api';
import { TranslateService } from '@ngx-translate/core';

import { DefaultModule } from '@module';

import { BaseDropdown, LibDropdownModule } from 'pn-core-code';

export interface translationsDto {
  id: string;
  name: string;
}

@Component({
  selector: 'shared-member-bank-dropdown',
  standalone: true,
  imports: [DefaultModule, LibDropdownModule],
  templateUrl: '/node_modules/pn-core-code/src/base/base-dropdown/base-dropdown.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberBankDropdownComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class MemberBankDropdownComponent extends BaseDropdown<translationsDto> {
  @Input() memberId: string | undefined;

  override inputChanges = ['memberId'];
  currentLang: string;

  constructor(
    protected override cdr: ChangeDetectorRef,
    protected override translateService: TranslateService,
    private membersService: MembersService
  ) {
    super(cdr, translateService);
    this.translateService.onLangChange.subscribe(t => {
      console.log('translateService', t);
      this.currentLang = t.lang;
      this.apiOptionListGet$();
    });
  }

  override ngOnInit() {
    this.currentLang = this.translateService.currentLang;
    super.ngOnInit();
  }

  protected override apiOptionListGet$() {
    return this.membersService.membersBankDropdownGet$(1, 999, this.memberId, this.currentLang).pipe(
      map(res => {
        let translationsList: any[] = [];
        for (const data of res) {
          for (const translation of data.bank.translations) {
            translationsList.push({
              id: data.id,
              name: translation.name + ' ' + data.bankBranchName + ' ' + data.bankAccountNo,
            });
          }

        }
        // console.log('translationsList', translationsList);
        return translationsList;
      }));
  }
}
